import Icon from '@material-ui/icons/Timeline';
import React from 'react';
import { Filter, ResourceList } from '../../../controllers';
import { DateTimeField, EnumField, LinkField } from '../../../fields';
import { BooleanInput, EnumInput, StaffTeamSelectInput, TeamMemberSelectInput } from '../../../inputs';

export default {
  Icon,
  dialogs: {
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <EnumField
          source="journey"
        />
        <EnumField
          source="stage"
        />
        <DateTimeField
          source="created_at"
        />
        <DateTimeField
          source="updated_at"
        />
        <LinkField
          label="Last Updated By"
          reference="users"
          source="stage_changer_id"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <EnumInput
          source="journey"
        />
        <StaffTeamSelectInput
          source="staff_team_id"
        />
        <TeamMemberSelectInput
          label="Owner"
          reference="users"
          source="owner_id"
        />
        <BooleanInput
          source="completed"
        />
      </Filter>
    )
  },
  resources: {
  },
};
